export default __webpack_public_path__ + "static/media/edge.bee4f6e8.png";